// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2-77m","info":"PatientInfo_info__3Y9KE"};